import React from 'react';

import './Frontpage.css';

import './common_styles/table.css'
import Measurements from "./components/measurement/Measurements";
import Statistics from "./components/statistics";
import CompanyMenu from "./components/company/CompanyMenu";
import Users from "./components/company/Users";
import {Redirect, Router} from "@reach/router";
import Menu from "./Menu";
import Api from "./components/company/Api";
import TopMeasurement from "./components/measurement/TopMeasurement";
import Summary from "./components/measurement/Summary";
import ApiDocs from "./components/company/ApiDocs";


export default props => (
    <Router>
        <Redirect noThrow from="/forest" to="measurement"/>
        <Menu path="/forest" user={props.user}>
            <TopMeasurement path="measurement">
                <Measurements path="/" accessToken={props.user.accessToken}/>
                <Summary path="summary" />
            </TopMeasurement>
            <Statistics path="statistics"/>
            <CompanyMenu path="company">
                <Redirect noThrow from="/" to="users"/>
                <Users path="users" accessToken={props.user.accessToken}/>
                <Api path="api" accessToken={props.user.accessToken}/>
                <ApiDocs path="api-docs" accessToken={props.user.accessToken}/>
            </CompanyMenu>
        </Menu>
    </Router>
);

